import React from 'react';
import { Switch, Route } from 'react-router';
import { Container, Navbar, NavbarBrand } from 'components/apollo';
import { NotFoundContainer } from 'views/shared/not-found';
import UnregisterDelete from '../views/unregister-delete';
import UnregisterRemain from '../views/unregister-remain';
import { appRoutes } from '../../../app-routes';
import iconImage from '../../register/router/AFRY-Logotype-Horizontal_White.svg';
import './unregister.css';

const parentRoutePath = appRoutes.unregister;

export const unregisterRoutes = {
  delete: `${parentRoutePath}/delete/:personId`,
  remain: `${parentRoutePath}/remain/:personId`,
};

const UnregisterRouter = () => {
  return (
    <div className="unregister">
      <Navbar dark fixed="top" expand="large">
        <Container>
          <NavbarBrand icon={iconImage} />
        </Container>
      </Navbar>
      <Switch>
        <Route exact path={unregisterRoutes.delete} component={UnregisterDelete} />
        <Route exact path={unregisterRoutes.remain} component={UnregisterRemain} />
        <Route path="*" component={NotFoundContainer} />
      </Switch>
    </div>
  );
};

export default UnregisterRouter;